import type { ComponentProps } from 'react';
import React, { useMemo } from 'react';
import styled from '@emotion/styled';
import type { WidthProps } from 'styled-system';
import { width } from 'styled-system';

import { Flex } from 'common/components/Flex';
import { ResponsiveLazyImage } from 'common/components/LazyImage';
import type { ResponsiveLazyImageProps } from 'common/components/LazyImage/types';
import { PictureTextKind } from '../enums';

export interface PictureBlockProps {
  kind: PictureTextKind;
  image?: ResponsiveLazyImageProps;
  href?: string;
  alt?: string;
}

const Picture = styled(ResponsiveLazyImage)<WidthProps>`
  ${width};
`;

const pictureStyles: ComponentProps<typeof Picture> = { width: 1 };

const getPictureWidth = (kind: PictureTextKind) => {
  switch (kind) {
    case PictureTextKind.FullWidthPicture:
    case PictureTextKind.DoublePictureText:
      return 1;
    case PictureTextKind.HalfPictureText:
      return [1, 1 / 2];
    default:
      return [1, 2 / 3];
  }
};

const PictureBlock = ({ kind, image, href, alt }: PictureBlockProps) => {
  const pictureWidth = useMemo(() => getPictureWidth(kind), [kind]);

  return (
    <Flex width={pictureWidth} {...(href ? { as: 'a', href } : {})}>
      <Picture {...pictureStyles} {...image} alt={alt || ''} />
    </Flex>
  );
};

export default PictureBlock;
